"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _CanvaCreateButton = _interopRequireDefault(require("./CanvaCreateButton"));

var _CanvaEditButton = _interopRequireDefault(require("./CanvaEditButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = _interopRequireDefault(require("immutable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _loadCanva = _interopRequireDefault(require("../utils/loadCanva"));

var _Canva = require("../constants/Canva");

var _Constants = require("../Constants");

var _reactRedux = require("react-redux");

var _Canva2 = require("../selectors/Canva");

var _Auth = require("../selectors/Auth");

var _UserSettings = require("../selectors/UserSettings");

var _BrowserTest = require("UIComponents/utils/BrowserTest");

var _UserSettings2 = require("../actions/UserSettings");

var _tracking = require("../actions/tracking");

var _Canva3 = require("../actions/Canva");

var CanvaButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CanvaButton, _Component);

  function CanvaButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CanvaButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CanvaButton).call(this, props));

    _this.handleCanvaApiLoaded = function () {
      if (_this.mounted && !window.__CANVA_API) {
        window.CanvaButton.initialize({
          apiKey: _Canva.CANVA_API_KEY
        }).then(function (canvaApi) {
          window.__CANVA_API = canvaApi;

          _this.props.canvaInitSucceeded();
        });
      }
    };

    _this.handleCanvaApiFailedLoad = function () {
      if (_this.mounted) {
        _this.props.canvaInitFailed();
      }
    };

    _this.dismissCanvaPopup = function () {
      var user = _this.props.user;

      if (_this.hasNotSeenCanvaPopup()) {
        _this.props.saveUserSettings(user.user_id, {
          hasSeenCanvaPopup: true
        });
      }
    };

    _this.hasNotSeenCanvaPopup = function () {
      var _this$props = _this.props,
          userSettingsHaveLoaded = _this$props.userSettingsHaveLoaded,
          userSettings = _this$props.userSettings;
      return userSettingsHaveLoaded && !userSettings.get('hasSeenCanvaPopup');
    };

    _this.openCanvaCreateModal = function (type) {
      _this.props.trackInteraction('Manage Files', 'create-canva-clicked');

      window.__CANVA_API.createDesign({
        publishLabel: 'Save',
        type: type,
        onDesignPublish: function onDesignPublish(_ref) {
          var designId = _ref.designId,
              exportUrl = _ref.exportUrl,
              designTitle = _ref.designTitle;

          _this.props.handleCanvaImport({
            canvaDesignId: designId,
            fileUrl: exportUrl,
            fileName: designTitle
          });
        }
      });
    };

    _this.openCanvaEditModal = function () {
      var file = _this.props.file;

      _this.props.trackInteraction('Manage Files', 'edit-canva-clicked');

      var designId = file.getIn(['meta', 'canva_id']);
      var originalFileId = file.get('id');

      window.__CANVA_API.editDesign({
        designId: designId,
        publishLabel: 'Save',
        onDesignPublish: function onDesignPublish(_ref2) {
          var exportUrl = _ref2.exportUrl,
              designTitle = _ref2.designTitle;

          _this.props.handleCanvaImport({
            originalFileId: originalFileId,
            canvaDesignId: designId,
            fileUrl: exportUrl,
            fileName: designTitle
          });
        }
      });
    };

    _this.isLoaded = function () {
      return _this.props.canvaInitStatus === _Constants.RequestStatus.SUCCEEDED || !!window.__CANVA_API;
    };

    _this.isDownloading = function () {
      return _this.props.canvaDownloadStatus === _Constants.RequestStatus.PENDING;
    };

    _this.disabledReason = function () {
      if ((0, _BrowserTest.isIE11)()) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.canvaNotSupportedForIE11"
        });
      } else if (_this.isDownloading()) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.canvaIsDownloading"
        });
      } else if (!_this.props.canvaIsSupportedForFilter) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.canvaNotSupportedForFilter"
        });
      } else if (!_this.isLoaded()) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.canvaNotLoaded"
        });
      }

      return null;
    };

    _this.renderLoadingButton = function () {
      var file = _this.props.file;
      return _react.default.createElement(_UILoadingButton.default, {
        className: "canva-loading-button " + (file ? '' : 'm-x-2'),
        disabled: true,
        loading: true,
        size: "small",
        use: "tertiary-light"
      });
    };

    _this.mounted = false;
    return _this;
  }

  (0, _createClass2.default)(CanvaButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (!(0, _BrowserTest.isIE11)()) {
        this.props.canvaInitAttempted();
        (0, _loadCanva.default)().then(this.handleCanvaApiLoaded).catch(this.handleCanvaApiFailedLoad).done();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          file = _this$props2.file,
          specificCanvaTemplates = _this$props2.specificCanvaTemplates;
      var disabledReason = this.disabledReason();
      var isDisabled = !!disabledReason;
      return file ? _react.default.createElement(_CanvaEditButton.default, {
        disabledReason: disabledReason,
        isDisabled: isDisabled,
        isDownloading: this.isDownloading(),
        loadingButton: this.renderLoadingButton(),
        openCanva: this.openCanvaEditModal
      }) : _react.default.createElement(_CanvaCreateButton.default, {
        disabledReason: disabledReason,
        isDisabled: isDisabled,
        dismissCanvaPopup: this.dismissCanvaPopup,
        hasNotSeenCanvaPopup: this.hasNotSeenCanvaPopup(),
        isDownloading: this.isDownloading(),
        loadingButton: this.renderLoadingButton(),
        openCanva: this.openCanvaCreateModal,
        specificCanvaTemplates: specificCanvaTemplates
      });
    }
  }]);
  return CanvaButton;
}(_react.Component);

CanvaButton.propTypes = {
  canvaDownloadStatus: _propTypes.default.oneOf(Object.keys(_Constants.RequestStatus)).isRequired,
  canvaInitAttempted: _propTypes.default.func.isRequired,
  canvaInitFailed: _propTypes.default.func.isRequired,
  canvaInitStatus: _propTypes.default.oneOf(Object.keys(_Constants.RequestStatus)).isRequired,
  canvaInitSucceeded: _propTypes.default.func.isRequired,
  canvaIsSupportedForFilter: _propTypes.default.bool,
  file: _propTypes.default.instanceOf(_immutable.default.Map),
  handleCanvaImport: _propTypes.default.func.isRequired,
  saveUserSettings: _propTypes.default.func.isRequired,
  specificCanvaTemplates: _propTypes.default.arrayOf(_propTypes.default.oneOf(_Canva.CANVA_TEMPLATES)),
  trackInteraction: _propTypes.default.func.isRequired,
  user: _propTypes.default.object.isRequired,
  userSettings: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  userSettingsHaveLoaded: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    canvaInitStatus: (0, _Canva2.getCanvaInitStatus)(state),
    canvaDownloadStatus: (0, _Canva2.getCanvaDownloadStatus)(state),
    canvaIsSupportedForFilter: (0, _Canva2.getCanvaIsSupportedForFilter)(state),
    user: (0, _Auth.getUser)(state),
    userSettings: (0, _UserSettings.getUserSettings)(state),
    userSettingsHaveLoaded: (0, _UserSettings.getUserSettingsHaveLoaded)(state)
  };
};

var mapDispatchToProps = {
  canvaInitAttempted: _Canva3.canvaInitAttempted,
  canvaInitFailed: _Canva3.canvaInitFailed,
  canvaInitSucceeded: _Canva3.canvaInitSucceeded,
  saveUserSettings: _UserSettings2.saveUserSettings,
  trackInteraction: _tracking.trackInteraction
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CanvaButton);

exports.default = _default;
module.exports = exports.default;